import React from 'react';

const AppFooter = ({ userSettings, setView, setKnowledgeTab }) => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="w-full py-16 mt-auto border-t border-border/10 bg-base transition-colors duration-300">
            <div className="max-w-4xl mx-auto px-6">
                <div className="flex flex-col items-center gap-8">
                    {/* Brand / Signature */}
                    <div className="flex flex-col items-center gap-2">
                        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center text-primary/40 mb-2">
                            <span className="font-black text-sm">K</span>
                        </div>
                        <p className="text-[10px] font-black tracking-[0.4em] uppercase text-muted/40 transition-colors">
                            &copy; {currentYear} Keyer's Journey &bull; W0HT
                        </p>
                    </div>

                    {/* Navigation */}
                    <div className="flex flex-wrap items-center justify-center gap-x-8 gap-y-4 text-[10px] font-bold uppercase tracking-[0.2em] text-muted/60">
                        <a
                            href="/knowledge"
                            onClick={(e) => {
                                e.preventDefault();
                                if (setKnowledgeTab) setKnowledgeTab('guide');
                                setView('knowledge');
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                            className="hover:text-primary transition-all cursor-pointer hover:tracking-[0.3em]"
                        >
                            User Guide
                        </a>
                        <a
                            href="/privacy"
                            onClick={(e) => {
                                e.preventDefault();
                                setView('legal_privacy');
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                            className="hover:text-primary transition-all cursor-pointer hover:tracking-[0.3em]"
                        >
                            Privacy
                        </a>
                        <a
                            href="/tos"
                            onClick={(e) => {
                                e.preventDefault();
                                setView('legal_tos');
                                window.scrollTo({ top: 0, behavior: 'smooth' });
                            }}
                            className="hover:text-primary transition-all cursor-pointer hover:tracking-[0.3em]"
                        >
                            Terms
                        </a>
                        <a
                            href="mailto:support@keyersjourney.com"
                            className="hover:text-primary transition-all cursor-pointer hover:tracking-[0.3em]"
                        >
                            Support
                        </a>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default AppFooter;
